import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateConfirmSuccessSnackbar,
  updateConfirmFailSnackbar
} from "../../actions/gatekeeper";

import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ErrorIcon from "@material-ui/icons/Error";
import CheckIcon from "@material-ui/icons/Check";
import { red, green } from "@material-ui/core/colors";

export const GatekeeperConfirmFailSnackbar = () => {
  const open = useSelector(state => state.gatekeeper.confirmFailSnackbar);
  const dispatch = useDispatch();
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      onClose={() => dispatch(updateConfirmFailSnackbar(false))}
      open={open}
      autoHideDuration={5000}
    >
      <SnackbarContent
        style={{ backgroundColor: red[600] }}
        message={
          <span style={{ alignItems: "center", display: "flex" }}>
            <ErrorIcon style={{ marginRight: 10 }} />
            There was a problem adding that team to the queue!
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={() => dispatch(updateConfirmFailSnackbar(false))}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
    </Snackbar>
  );
};

export const GatekeeperConfirmSuccessSnackbar = () => {
  const open = useSelector(state => state.gatekeeper.confirmSuccessSnackbar);
  const dispatch = useDispatch();
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      onClose={() => dispatch(updateConfirmSuccessSnackbar(false))}
      open={open}
      autoHideDuration={3000}
    >
      <SnackbarContent
        style={{ backgroundColor: green[600] }}
        message={
          <span style={{ alignItems: "center", display: "flex" }}>
            <CheckIcon style={{ marginRight: 10 }} />
            Team added to the queue
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={() => dispatch(updateConfirmSuccessSnackbar(false))}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
    </Snackbar>
  );
};
